import { getAddressRegionOptions } from '@/lib/address-region-options'
import {
  applyCustomerAddressPlace,
  clearCustomerAddressVerification,
} from '@/lib/services/customers/customers.address'

export function CustomerAddressFieldInputs({ form, id, prefix = 'physical_address' }) {
  const clearVerification = () => clearCustomerAddressVerification(form, prefix)

  return (
    <>
      <form.AppField name={`${prefix}.line1`}>
        {(field) => (
          <field.AddressSearch
            id={`${id}-${prefix}-line1`}
            label="Street Address"
            onChange={clearVerification}
            onAddressSelected={(place) => applyCustomerAddressPlace(form, prefix, place)}
          />
        )}
      </form.AppField>
      <div className="@container/customer-address-fields">
        <div className="grid grid-cols-6 gap-4 @lg/customer-address-fields:grid-cols-12">
          <div className="col-span-6 @lg/customer-address-fields:col-span-12">
            <form.AppField name={`${prefix}.line2`}>
              {(field) => (
                <field.TextInput
                  id={`${id}-${prefix}-line2`}
                  label="Apt, Suite, Building"
                  placeholder="Apartment, suite, unit, etc."
                />
              )}
            </form.AppField>
          </div>
          <div className="col-span-6 @lg/customer-address-fields:col-span-6">
            <form.AppField name={`${prefix}.city`}>
              {(field) => (
                <field.TextInput
                  id={`${id}-${prefix}-city`}
                  label="City"
                  placeholder="City"
                  onChange={clearVerification}
                />
              )}
            </form.AppField>
          </div>
          <div className="col-span-3 @lg/customer-address-fields:col-span-3">
            <form.AppField name={`${prefix}.state`}>
              {(field) => (
                <field.SelectInput
                  id={`${id}-${prefix}-state`}
                  label="State"
                  placeholder="State"
                  options={getAddressRegionOptions(field.state.value)}
                  onValueChange={clearVerification}
                />
              )}
            </form.AppField>
          </div>
          <div className="col-span-3 @lg/customer-address-fields:col-span-3">
            <form.AppField name={`${prefix}.postal_code`}>
              {(field) => (
                <field.TextInput
                  id={`${id}-${prefix}-postal-code`}
                  label="Zip"
                  placeholder="Zip code"
                  onChange={clearVerification}
                />
              )}
            </form.AppField>
          </div>
        </div>
      </div>
    </>
  )
}
